import { createReducer } from './util';
import * as actionTypes from '../typedefs/actionTypes';
import { LocationSettingsFetchedAction } from '../typedefs/actions';
import { LocationState as State } from '../typedefs/store';

const initialState: State = {} as State;

const handlers = {
    [actionTypes.LOCATION_SETTINGS_FETCHED]: locationSettingsFetched,
};

function locationSettingsFetched(state: State, action: LocationSettingsFetchedAction) {
    const { payload: { settings } } = action;
    return {
        ...state,
        ...{
            id: settings.id,
            name: settings.name,
            avatar: settings.avatar,
            phone: settings.phoneNumber,
            customerId: settings.customer.id,
            offlineMessage: settings.offlineMessage,
            teamIds: settings.teams.map(team => team.id),
        },
    };
}

export default createReducer(initialState, handlers);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/location.ts